<template>
  <div class="zy-health sleep-page">
    <!-- 顶部导航栏 - 参考 skinTemperature 页面 -->
    <header class="sleep-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <button 
          class="nav-back-btn" 
          @click="goBack"
          :style="{top: pageBackBtnTop + 'px'}"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <div class="nav-title">睡眠</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="sleep-content" :style="{paddingTop: pageContentTop + 'px'}">
      <!-- 日/周/月维度切换（保留原有日期筛选） -->
      <div class="segmented-control">
        <div
          v-for="(tab, index) in dimensionTabs"
          :key="'sleep-dim-' + index"
          class="segment-item"
          :class="{ active: activeDimension === index }"
          @click="selectDimension(index)"
        >
          {{ tab }}
        </div>
      </div>

      <!-- 睡眠时长数据卡片 - 参考 bloodOxygen 页面结构 -->
      <div class="sleep-header-card">
        <div class="sleep-header-top">
          <div class="sleep-title-row">
            <div class="sleep-title-section">
              <i class="sleep-icon"></i>
              <span class="sleep-title-text">{{ queryType === 1 ? '睡眠时长' : '每日睡眠阶段' }}</span>
            </div>
            <div class="sleep-date" @click="timeClick()">
              {{ displayDateLabel }}
              <i class="el-icon-caret-bottom"></i>
            </div>
          </div>
          <div
            v-if="queryType !== 1 && selectedSleepDailyDateText"
            class="sleep-selected-day"
          >{{ selectedSleepDailyDateText }}</div>
          <div
            v-if="queryType === 1 || hasSelectedSleepDailyData"
            class="sleep-value-section"
          >
            <span class="sleep-value">{{ totalTime || '--' }}</span>
          </div>
          <div class="sleep-time-range" v-if="sleepStartTime && sleepEndTime">
            {{ sleepStartTime }} ~ {{ sleepEndTime }}
          </div>
          <div class="sleep-time-range sleep-time-range--hint" v-else-if="queryType !== 1 && !hasSelectedSleepDailyData">
            {{ periodHint }}
          </div>
        </div>
        <!-- 日视图：圆形图表 -->
        <div v-if="queryType === 1" class="sleep-chart-container">
          <div class="sleep-chart-wrapper">
            <div ref="sleepChart" class="sleep-chart"></div>
            <!-- 中心显示睡眠得分 -->
            <div class="sleep-chart-score">
              <div class="sleep-chart-score-value">{{score || '--'}}</div>
              <div class="sleep-chart-score-label">睡眠得分</div>
            </div>
          </div>
        </div>
        <!-- 周/月视图：每日睡眠阶段柱状图 -->
        <div v-else class="sleep-daily-chart-wrap">
          <div ref="sleepDailyChart" class="sleep-daily-chart"></div>
          <div v-if="!sleepDailyList.length" class="sleep-daily-empty">暂无数据</div>
          <div v-else class="sleep-daily-tip">点击柱状图切换日期，查看当日睡眠详情</div>
        </div>
        <!-- 睡眠阶段图例 -->
        <div class="sleep-stage-legend">
          <div class="sleep-stage-item">
            <div class="stage-label-row">
              <div class="stage-icon deep-sleep-icon"></div>
              <span class="stage-label">深睡时长</span>
            </div>
            <span class="stage-value">
              <span class="stage-value-number">{{deepSleep}}</span>
              <span class="stage-value-unit">分钟</span>
            </span>
          </div>
          <div class="sleep-stage-item">
            <div class="stage-label-row">
              <div class="stage-icon light-sleep-icon"></div>
              <span class="stage-label">浅睡时长</span>
            </div>
            <span class="stage-value">
              <span class="stage-value-number">{{lightSleep}}</span>
              <span class="stage-value-unit">分钟</span>
            </span>
          </div>
          <div class="sleep-stage-item">
            <div class="stage-label-row">
              <div class="stage-icon rem-sleep-icon"></div>
              <span class="stage-label">快速眼动</span>
            </div>
            <span class="stage-value">
              <span class="stage-value-number">{{rem}}</span>
              <span class="stage-value-unit">分钟</span>
            </span>
          </div>
        </div>
      </div>
       
      <!-- 选中日详情：日视图用 sleep 接口；周/月用 daily-list 里 sleepInfo（对齐 serviceLogDetail） -->
      <template v-if="queryType === 1 || hasSelectedSleepDailyData">
      <!-- 睡眠心率卡片 -->
      <div class="sleep-heart-rate-card">
        <div class="shr-header">
          <div class="shr-title-section">
            <div class="shr-icon"></div>
            <span class="shr-title-text">睡眠心率</span>
          </div>
        </div>
        
        <div class="shr-chart-wrapper">
          <echarts1 :detailTimes="detailTimes" :details="details"></echarts1>
        </div>
        
        <div class="shr-stats">
          <div class="shr-stat-item">
            <span class="shr-stat-label">睡眠平均心率</span>
            <span class="shr-stat-value">{{heartAvg}}次/分钟</span>
          </div>
          <div class="shr-stat-item">
            <span class="shr-stat-label">
              睡眠低血氧异常
              <div
                class="shr-question"
                @click="
                  bulletFrameIf = true;
                  title = '什么是睡眠低血氧异常';
                  name1 =
                    '睡眠低血氧异常就是在睡眠期间的血氧水平掉到了正常值以下(通常是低于90%)，它与睡眠过程中的低通气呼吸障碍症状有关，是诊断和评估睡眠呼吸问题严重性的重要依据。';
                "
              >
                ?
              </div>
            </span>
            <span class="shr-stat-value">{{breathWarn}}次</span>
          </div>
        </div>
      </div>
    <!-- 睡眠时长 -->
    <div class="sleep-stats-card">
      <div class="ssc-title">
        <span>睡眠时长</span>
      </div>
      <div class="ssc-content">
        <div class="ssc-value-row">
          <div class="ssc-main-value">{{totalTime}}</div>
          <div class="ssc-status-tag">
            <div class="ssc-state ssc-state-normal" v-if="sleepState == '正常'">{{sleepState}}</div>
            <div class="ssc-state ssc-state-low" v-else-if="sleepState == '偏低'">{{sleepState}}</div>
            <div class="ssc-state ssc-state-high" v-else-if="sleepState == '偏高'">{{sleepState}}</div>
          </div>
        </div>
        <div class="ssc-reference">
          <span>参考值：{{sleepRef}}</span>
          <span>多于{{sleepCompRate}}%的用户</span>
        </div>
      </div>
    </div>
    <!-- 深睡时长 -->
    <div class="sleep-stats-card">
      <div class="ssc-title">
        <span>深睡时长</span>
      </div>
      <div class="ssc-content">
        <div class="ssc-value-row">
          <div class="ssc-main-value">{{deepSleep}}分钟</div>
          <div class="ssc-status-tag">
            <div class="ssc-state ssc-state-normal" v-if="deepState == '正常'">{{deepState}}</div>
            <div class="ssc-state ssc-state-low" v-else-if="deepState == '偏低'">{{deepState}}</div>
            <div class="ssc-state ssc-state-high" v-else-if="deepState == '偏高'">{{deepState}}</div>
          </div>
        </div>
        <div class="ssc-progress-wrapper">
          <div class="ssc-progress-bar">
            <div class="ssc-progress-fill" :style="{ width: deepRate + '%' }"></div>
            <div class="ssc-progress-dot" :style="{ left: deepRate - 1 + '%' }">
              <div class="ssc-progress-label">占比{{ deepRate }}%</div>
            </div>
          </div>
        </div>
        <div class="ssc-reference">
          <span>参考值：{{deepRef}}</span>
          <span>多于{{deepCompRate}}%的用户</span>
        </div>
      </div>
    </div>
    <!-- 快速眼动时长 -->
    <div class="sleep-stats-card">
      <div class="ssc-title">
        <span>
          快速眼动时长
          <div
            class="ssc-question"
            @click="
              bulletFrameIf = true;
              title = '什么是快速眼动（REM）';
              name1 =
                '快速眼动睡眠期（REM）是睡眠分期中一个重要的阶段，通常也是梦境产生的阶段。快速眼动睡眠的唤醒阀高于浅睡眠，低于深睡眠。在此阶段，肌肉一般处于松弛状态，眼球会不自觉的做快速无规则的转动。快速眼动睡眠时间对于精神健康非常重要，有助于提升创造力，舒缓压力。';
            "
          >
            ?
          </div>
        </span>
      </div>
      <div class="ssc-content">
        <div class="ssc-value-row">
          <div class="ssc-main-value">{{rem}}分钟</div>
          <div class="ssc-status-tag">
            <div class="ssc-state ssc-state-normal" v-if="remState == '正常'">{{remState}}</div>
            <div class="ssc-state ssc-state-low" v-else-if="remState == '偏低'">{{remState}}</div>
            <div class="ssc-state ssc-state-high" v-else-if="remState == '偏高'">{{remState}}</div>
          </div>
        </div>
        <div class="ssc-progress-wrapper">
          <div class="ssc-progress-bar">
            <div class="ssc-progress-fill" :style="{ width: remCompRate + '%' }"></div>
            <div class="ssc-progress-dot" :style="{ left: remCompRate - 1 + '%' }">
              <div class="ssc-progress-label">占比{{ remCompRate }}%</div>
            </div>
          </div>
        </div>
        <div class="ssc-reference">
          <span>参考值：{{remRef}}</span>
        </div>
      </div>
    </div>
    <!-- 清醒次数 -->
    <div class="sleep-stats-card">
      <div class="ssc-title">
        <span>夜间清醒次数</span>
      </div>
      <div class="ssc-content">
        <div class="ssc-value-row">
          <div class="ssc-main-value">{{wakeCount}}次</div>
          <div class="ssc-status-tag">
            <div class="ssc-state ssc-state-normal" v-if="wakeState == '正常'">{{wakeState}}</div>
            <div class="ssc-state ssc-state-low" v-else-if="wakeState == '偏低'">{{wakeState}}</div>
            <div class="ssc-state ssc-state-high" v-else-if="wakeState == '偏高'">{{wakeState}}</div>
          </div>
        </div>
        <div class="ssc-reference">
          <span>参考值：{{wakeRef}}</span>
        </div>
      </div>
    </div>
      </template>
      <picke
        @child-method="parentMethod"
        :value="value"
        :leftTime="leftTime"
      ></picke>
      <bulletFrame
        @close-method="closeMethod"
        :bulletFrameIf="bulletFrameIf"
        :title="title"
        :name="name1"
      ></bulletFrame>

      <!-- 免责声明 + 开始分析（参考血氧页；仅聚合页 Tab 内嵌时展示按钮） -->
      <div class="health-disclaimer">
        <p>注:非医疗设备,结果仅供参考,如有不适,请及时就医</p>
        <StartAnalysisCta :embedded="embedded" @click="$emit('start-analysis')" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import * as echarts from "echarts";
import { sleep, sleepDailyList } from '@/api/activity'
import { SleepWave, EventBus } from ".././canvas/js/sleepWave";
import StartAnalysisCta from '@/components/StartAnalysisCta'
export default {
  name: 'sleep',
  props: {
    /**
     * 是否为聚合页 Tab 内嵌场景（内嵌时才展示开始分析按钮）
     * @type {boolean}
     */
    embedded: { type: Boolean, default: false }
  },
  data() {
    return {
      wake:0,
      leftTime: "",
      nameType: "",
      title: "",
      name1: "",
      bulletFrameIf: false,
      data: [],
      details:[],
      detailTimes:[],
      progress: 50,
      echartsTime: "00:00",
      name: "0",
      time: "1",
      time1: "2",
      newtime: "",
      value: false,
      week: "",
      chartInstance: null,
      totalTime:'',
      score:0,
      lightSleep:0,
      wakeCount:0,
      rem:0,
      deepSleep:0,
      totalTime:0,
      heartAvg:0,
      breathWarn:0,
      sleepRef:0,
      sleepState:'',
      sleepCompRate:0,
      deepRate:0,
      deepState:'',
      deepRef:0,
      deepCompRate:0,
      remCompRate:0,
      remRef:0,
      wakeState:'',
      wakeRef:0,
      remState:'',
      sleepStartTime:'',
      sleepEndTime:'',
      /** 日/周/月 Tab 索引 */
      activeDimension: 0,
      dimensionTabs: ['日', '周', '月'],
      /** 周/月每日睡眠列表 */
      sleepDailyList: [],
      sleepDailyChart: null,
      /** 周/月选中的每日索引 */
      selectedSleepDailyIndex: -1
    };
  },
  components: {
    picke: () => import("@/components/picke"),
    bulletFrame: () => import("@/components/bulletFrame"),
    echarts1: () => import("@/views/echarts"),
    StartAnalysisCta,
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight', 'pageContentTop', 'pageBackBtnTop']),
    /**
     * 查询维度：1-日 2-周 3-月
     * @returns {number}
     */
    queryType() {
      return this.activeDimension + 1
    },
    /**
     * 周/月当前选中项
     * @returns {Object|null}
     */
    selectedSleepDailyItem() {
      const list = this.sleepDailyList
      if (!Array.isArray(list) || this.selectedSleepDailyIndex < 0) return null
      return list[this.selectedSleepDailyIndex] || null
    },
    /**
     * 选中日是否有 sleepInfo 数据
     * @returns {boolean}
     */
    hasSelectedSleepDailyData() {
      return this.hasSleepDailyItemData(this.selectedSleepDailyItem)
    },
    /**
     * 选中日日期文案（周视图带星期，避免被长日期挤掉）
     * @returns {string}
     */
    selectedSleepDailyDateText() {
      const item = this.selectedSleepDailyItem
      if (!item || !item.dataDay) return ''
      const raw = String(item.dataDay)
      const date = new Date(`${raw}T00:00:00`)
      if (Number.isNaN(date.getTime())) {
        const parts = raw.split('-')
        if (parts.length >= 3) return `${Number(parts[1])}月${Number(parts[2])}日`
        return raw
      }
      const m = date.getMonth() + 1
      const d = date.getDate()
      const weekNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      const weekText = weekNames[date.getDay()]
      if (this.queryType === 2) {
        return `${m}月${d}日（${weekText}）`
      }
      return `${m}月${d}日`
    },
    /**
     * 顶部日期展示（日/周/月）
     * @returns {string}
     */
    displayDateLabel() {
      if (!this.time || this.time === '1') {
        return (this.newtime || '') + (this.week ? ' ' + this.week : '')
      }
      try {
        const dateStr = this.getTransferTime(this.transferTime(this.time))
        const oDay = new Date(dateStr.replace(/-/g, '/'))
        if (Number.isNaN(oDay.getTime())) {
          return (this.newtime || '') + (this.week ? ' ' + this.week : '')
        }
        const y = oDay.getFullYear()
        const m = oDay.getMonth() + 1
        const d = oDay.getDate()
        if (this.queryType === 3) return `${y}年${m}月`
        if (this.queryType === 2) {
          const day = oDay.getDay() || 7
          const monday = new Date(oDay)
          monday.setDate(oDay.getDate() - day + 1)
          const sunday = new Date(monday)
          sunday.setDate(monday.getDate() + 6)
          return `${monday.getFullYear()}年${monday.getMonth() + 1}月${monday.getDate()}日 - ${sunday.getMonth() + 1}月${sunday.getDate()}日`
        }
        return `${this.newtime || `${m}月${d}日`} ${this.week || ''}`.trim()
      } catch (e) {
        return (this.newtime || '') + (this.week ? ' ' + this.week : '')
      }
    },
    /**
     * 周/月提示文案
     * @returns {string}
     */
    periodHint() {
      return '点击柱状图切换日期，查看当日睡眠详情'
    }
  },
  mounted() {
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "37.5px";
        }
    // this.timeRight = this.$route.query.sleepUpTime
    document.title = '睡眠' 
    // 设置 body 背景色，确保滚动时背景色不丢失
    document.body.style.backgroundColor = '#F2F3F5';
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
    window.addEventListener("resize", this.handleResize);
    // this.initChart();
   
  },
  beforeDestroy() {
    // 恢复 body 背景色
    document.body.style.backgroundColor = '';
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
    window.removeEventListener("resize", this.handleResize);
    
    // 销毁图表实例
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
    if (this.sleepDailyChart) {
      this.sleepDailyChart.dispose()
      this.sleepDailyChart = null
    }
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 切换日/周/月（不影响原有日期选择器）
     * @param {number} index
     * @returns {void}
     */
    selectDimension(index) {
      if (this.activeDimension === index) return
      this.activeDimension = index
      this.selectedSleepDailyIndex = -1
      if (index !== 0 && this.chartInstance) {
        this.chartInstance.dispose()
        this.chartInstance = null
      }
      if (index === 0 && this.sleepDailyChart) {
        this.sleepDailyChart.dispose()
        this.sleepDailyChart = null
      }
      this.getData()
    },
    getData() {
      var obj = {
        type: this.queryType,
        dat: this.getTransferTime(this.transferTime(this.time))
      }
      // 周/月：对齐 serviceLogDetail
      // GET /monitor/v1/sleep/{userCode}/{type}/daily-list/{day}
      if (this.queryType !== 1) {
        const userCode = localStorage.getItem('userCode') || ''
        if (!userCode) {
          this.$toast('用户信息缺失，请重新登录')
          return
        }
        this.loadSleepDailyList({
          ...obj,
          userCode
        })
        return
      }
      sleep(obj).then((res)=> {
        if(res.code == 1000) {
          this.applySleepInfoData(res.data)
          this.$nextTick(() => {
            this.initChart();
          })
        }
        console.log(res.data)
      })
    },
    /**
     * 将 SleepInfoResp 灌入页面字段（日接口 / daily-list.sleepInfo 共用）
     * @param {Object|null|undefined} data
     * @returns {void}
     */
    applySleepInfoData(data) {
      if (data != null) {
        if (data.wake < 0) {
          this.wake = 0
        } else {
          this.wake = data.wake || 0
        }
        if (data.sleepStartTime) {
          this.sleepStartTime = String(data.sleepStartTime).slice(-14).replace(/.{3}$/, '')
          this.sleepEndTime = data.sleepEndTime
            ? String(data.sleepEndTime).slice(-14).replace(/.{3}$/, '')
            : ''
        } else {
          this.sleepStartTime = ''
          this.sleepEndTime = ''
        }
        this.score = data.score || 0
        this.lightSleep = data.lightSleep || 0
        this.wakeCount = data.wakeCount || 0
        this.rem = data.rem || 0
        this.deepSleep = data.deepSleep || 0
        this.totalTime = data.totalTime || 0
        this.data = [
          { value: this.deepSleep, name: '深睡', itemStyle: { color: '#008C00' } },
          { value: this.lightSleep, name: '浅睡', itemStyle: { color: '#00C275' } },
          { value: this.rem, name: '快速眼动', itemStyle: { color: '#FF9315' } },
          { value: this.wakeCount, name: '清醒', itemStyle: { color: '#FFC215' } }
        ]
        this.breathWarn = data.breathWarn || 0
        this.heartAvg = data.heartAvg || 0
        this.details = data.details || []
        this.detailTimes = data.detailTimes || []
        this.sleepRef = data.sleepRef
        this.sleepState = data.sleepState
        this.sleepCompRate = data.sleepCompRate || 0
        this.deepState = data.deepState
        this.deepRef = data.deepRef || 0
        this.deepCompRate = data.deepCompRate || 0
        this.remRef = data.remRef || 0
        this.wakeState = data.wakeState
        this.wakeRef = data.wakeRef
        this.remState = data.remState
        this.deepRate = data.deepRate || 0
        this.remCompRate = data.remCompRate || 0
        return
      }
      this.sleepStartTime = ''
      this.sleepEndTime = ''
      this.wake = 0
      this.score = 0
      this.lightSleep = 0
      this.wakeCount = 0
      this.rem = 0
      this.deepSleep = 0
      this.totalTime = 0
      this.data = [
        { value: 0, name: '深睡', itemStyle: { color: '#008C00' } },
        { value: 0, name: '浅睡', itemStyle: { color: '#00C275' } },
        { value: 0, name: '快速眼动', itemStyle: { color: '#FF9315' } },
        { value: 0, name: '清醒', itemStyle: { color: '#FFC215' } }
      ]
      this.breathWarn = 0
      this.heartAvg = 0
      this.details = []
      this.detailTimes = []
      this.sleepRef = ''
      this.sleepState = ''
      this.sleepCompRate = 0
      this.deepState = ''
      this.deepRef = 0
      this.deepCompRate = 0
      this.remRef = 0
      this.wakeState = ''
      this.wakeRef = ''
      this.remState = ''
      this.deepRate = 0
      this.remCompRate = 0
    },
    /**
     * 判断每日睡眠列表单项是否有数据（对齐 serviceLogDetail）
     * @param {Object|null} item SleepDailyInfoResp
     * @returns {boolean}
     */
    hasSleepDailyItemData(item) {
      if (!item || !item.sleepInfo) return false
      const info = item.sleepInfo
      return (
        info.deepSleep != null ||
        info.lightSleep != null ||
        info.rem != null ||
        Boolean(info.totalTime) ||
        info.score != null ||
        info.heartAvg != null ||
        info.wakeCount != null ||
        (Array.isArray(info.detailTimes) && info.detailTimes.length && Array.isArray(info.details) && info.details.length)
      )
    },
    /**
     * 加载周/月每日睡眠列表
     * GET /monitor/v1/sleep/{userCode}/{type}/daily-list/{day}
     * @param {{ userCode: string, type: number, dat: string }} obj
     * @returns {void}
     */
    loadSleepDailyList(obj) {
      sleepDailyList(obj).then((res) => {
        if (res && res.code == 1000 && Array.isArray(res.data)) {
          this.sleepDailyList = res.data
        } else {
          this.sleepDailyList = []
          this.$toast((res && res.msg) || '未查询到数据！')
        }
        this.initSelectedSleepDailyIndex()
        this.applySelectedSleepDailyItem()
        this.$nextTick(() => {
          this.renderSleepDailyChart()
        })
      }).catch(() => {
        this.sleepDailyList = []
        this.selectedSleepDailyIndex = -1
        this.applySleepInfoData(null)
        this.$toast('获取睡眠数据失败')
      })
    },
    /**
     * 默认选中最近一条有数据的日期（对齐 serviceLogDetail）
     * @returns {void}
     */
    initSelectedSleepDailyIndex() {
      const list = this.sleepDailyList
      if (!Array.isArray(list) || !list.length) {
        this.selectedSleepDailyIndex = -1
        return
      }
      for (let i = list.length - 1; i >= 0; i -= 1) {
        if (this.hasSleepDailyItemData(list[i])) {
          this.selectedSleepDailyIndex = i
          return
        }
      }
      this.selectedSleepDailyIndex = list.length - 1
    },
    /**
     * 用选中日的 sleepInfo 灌入详情区
     * @returns {void}
     */
    applySelectedSleepDailyItem() {
      const item = this.selectedSleepDailyItem
      this.applySleepInfoData(item && item.sleepInfo ? item.sleepInfo : null)
    },
    /**
     * 周/月柱图点击选中某一天
     * @param {number} index
     * @returns {void}
     */
    handleSelectSleepDailyItem(index) {
      const list = this.sleepDailyList
      if (!Array.isArray(list) || index < 0 || index >= list.length) return
      if (this.selectedSleepDailyIndex === index) return
      this.selectedSleepDailyIndex = index
      this.applySelectedSleepDailyItem()
      this.renderSleepDailyChart()
    },
    /**
     * 格式化周/月 X 轴日期
     * @param {string} dateStr
     * @returns {string}
     */
    formatSleepDailyAxisLabel(dateStr) {
      if (!dateStr) return ''
      const parts = String(dateStr).split('-')
      if (parts.length < 3) return dateStr
      if (this.queryType === 2) {
        const weekNames = ['日', '一', '二', '三', '四', '五', '六']
        const d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]))
        return '周' + weekNames[d.getDay()]
      }
      return Number(parts[1]) + '/' + Number(parts[2])
    },
    /**
     * 渲染周/月每日睡眠阶段堆叠柱（对齐 serviceLogDetail）
     * @returns {void}
     */
    renderSleepDailyChart() {
      const el = this.$refs.sleepDailyChart
      if (!el) return
      if (this.sleepDailyChart) {
        this.sleepDailyChart.dispose()
        this.sleepDailyChart = null
      }
      const list = this.sleepDailyList || []
      if (!list.length) return
      this.sleepDailyChart = echarts.init(el)
      const isMonth = this.queryType === 3
      const selectedIndex = this.selectedSleepDailyIndex
      const categories = list.map((item) => this.formatSleepDailyAxisLabel(item.dataDay))
      const deepData = list.map((item) => Number((item.sleepInfo && item.sleepInfo.deepSleep) || 0))
      const lightData = list.map((item) => Number((item.sleepInfo && item.sleepInfo.lightSleep) || 0))
      const remData = list.map((item) => Number((item.sleepInfo && item.sleepInfo.rem) || 0))
      const barPalette = {
        deep: { from: '#7B6CFF', to: '#4B37FF', inactive: 'rgba(123, 108, 255, 0.22)' },
        light: { from: '#A8A4FF', to: '#7B76FF', inactive: 'rgba(168, 164, 255, 0.22)' },
        rem: { from: '#6AE892', to: '#43D867', inactive: 'rgba(106, 232, 146, 0.22)' }
      }
      /**
       * @param {number} dataIndex
       * @param {{from:string,to:string,inactive:string}} palette
       * @returns {string|Object}
       */
      const buildBarColor = (dataIndex, palette) => {
        if (selectedIndex >= 0 && dataIndex !== selectedIndex) {
          return palette.inactive
        }
        return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: palette.from },
          { offset: 1, color: palette.to }
        ])
      }
      /**
       * @param {number} dataIndex
       * @param {{from:string,to:string,inactive:string}} palette
       * @param {boolean} isTopSegment
       * @returns {Object}
       */
      const buildBarItemStyle = (dataIndex, palette, isTopSegment = false) => ({
        color: buildBarColor(dataIndex, palette),
        borderRadius: isTopSegment ? [6, 6, 0, 0] : [0, 0, 0, 0]
      })
      /**
       * @param {number} index
       * @returns {string}
       */
      const getTopSegment = (index) => {
        if (remData[index] > 0) return 'rem'
        if (lightData[index] > 0) return 'light'
        if (deepData[index] > 0) return 'deep'
        return ''
      }
      const self = this
      this.sleepDailyChart.setOption({
        grid: { left: 12, right: 12, top: 16, bottom: isMonth ? 28 : 28, containLabel: true },
        tooltip: {
          trigger: 'axis',
          showContent: false,
          axisPointer: { type: 'shadow' }
        },
        legend: { show: false },
        xAxis: {
          type: 'category',
          data: categories,
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#e5e7eb' } },
          axisLabel: {
            // 月视图：约每 5 天显示一个刻度，避免底部过密
            interval: isMonth
              ? (index) => index % 5 === 0 || index === categories.length - 1
              : 0,
            rotate: 0,
            color: '#8a9691',
            fontSize: 11,
            hideOverlap: true
          }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } },
          axisLabel: { color: '#8a9691', fontSize: 11 }
        },
        series: [
          {
            name: '深睡',
            type: 'bar',
            stack: 'sleep',
            barMaxWidth: isMonth ? 14 : 28,
            emphasis: { disabled: true },
            data: deepData.map((val, index) => ({
              value: val,
              itemStyle: buildBarItemStyle(index, barPalette.deep, getTopSegment(index) === 'deep')
            }))
          },
          {
            name: '浅睡',
            type: 'bar',
            stack: 'sleep',
            barMaxWidth: isMonth ? 14 : 28,
            emphasis: { disabled: true },
            data: lightData.map((val, index) => ({
              value: val,
              itemStyle: buildBarItemStyle(index, barPalette.light, getTopSegment(index) === 'light')
            }))
          },
          {
            name: '快速眼动',
            type: 'bar',
            stack: 'sleep',
            barMaxWidth: isMonth ? 14 : 28,
            emphasis: { disabled: true },
            data: remData.map((val, index) => ({
              value: val,
              itemStyle: buildBarItemStyle(index, barPalette.rem, getTopSegment(index) === 'rem')
            }))
          }
        ]
      }, true)
      this.sleepDailyChart.off('click')
      this.sleepDailyChart.on('click', (params) => {
        if (params == null || params.dataIndex == null) return
        self.handleSelectSleepDailyItem(params.dataIndex)
      })
    },
    startDrag(e) {
      EventBus.$on("title", (message) => {
        console.log(message);
        if (message == 1) {
          this.nameType = "深睡";
        } else if (message == 2) {
          this.nameType = "浅睡";
        } else if (message == 3) {
          this.nameType = "快速眼动";
        } else if (message == 4) {
          this.nameType = "清醒";
        }
      });
      EventBus.$on("value", (message) => {
        console.log(message);
        this.name = message;
      });
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
      if (this.sleepDailyChart) {
        this.sleepDailyChart.resize()
      }
    },
    myCanvasClick(e) {},
    renderCardList(data) {
      this.echartsTime = data.name;
      this.name = data.value;
    },
    /**
     * 初始化echarts图表 - 参考 healthHomePage Sleep 组件
     */
    initChart() {
      if (!this.$refs.sleepChart) return;
      
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      
      this.chartInstance = echarts.init(this.$refs.sleepChart);
      
      // 计算睡眠时间段
      const sleepStartTime = this.sleepStartTime || '';
      const sleepEndTime = this.sleepEndTime || '';
      
      // 解析时间并转换为角度
      const startAngle = this.timeToAngle(sleepStartTime);
      const endAngle = this.timeToAngle(sleepEndTime);
      
      // 计算各睡眠阶段的时长
      const totalTime = this.parseDuration(this.totalTime) || 0;
      
      // 处理深睡数据：可能是数字（分钟）或字符串
      let deepSleepTime = 0;
      if (this.deepSleep !== undefined && this.deepSleep !== null) {
        if (typeof this.deepSleep === 'number') {
          deepSleepTime = this.deepSleep;
        } else {
          deepSleepTime = this.parseDuration(this.deepSleep) || 0;
        }
      }
      
      // 处理浅睡数据
      let lightSleepTime = 0;
      if (this.lightSleep !== undefined && this.lightSleep !== null) {
        if (typeof this.lightSleep === 'number') {
          lightSleepTime = this.lightSleep;
        } else {
          lightSleepTime = this.parseDuration(this.lightSleep) || 0;
        }
      }
      
      // 处理快速眼动数据
      let remTime = 0;
      if (this.rem !== undefined && this.rem !== null) {
        if (typeof this.rem === 'number') {
          remTime = this.rem;
        } else {
          remTime = this.parseDuration(this.rem) || 0;
        }
      }
      
      // 计算各阶段的角度范围
      const sleepDuration = endAngle > startAngle ? endAngle - startAngle : (360 - startAngle + endAngle);
      
      // 如果总时长为0，尝试使用各阶段时长之和
      const calculatedTotalTime = totalTime || (deepSleepTime + lightSleepTime + remTime);
      
      // 构建饼图数据 - 使用 healthHomePage 的颜色配置
      const pieData = [];
      if (deepSleepTime > 0) {
        pieData.push({
          value: deepSleepTime,
          name: '深睡',
          itemStyle: {
            color: '#4B37FF'
          }
        });
      }
      if (lightSleepTime > 0) {
        pieData.push({
          value: lightSleepTime,
          name: '浅睡',
          itemStyle: {
            color: '#7B76FF'
          }
        });
      }
      if (remTime > 0) {
        pieData.push({
          value: remTime,
          name: '快速眼动',
          itemStyle: {
            color: '#43D867'
          }
        });
      }
      
      // 计算饼图起始角度
      // pie图的startAngle：0度在右侧，顺时针为正
      // 需要从睡眠开始时间开始，所以使用startAngle，并加上90度偏移（因为0度在右侧，顶部是-90度）
      const pieStartAngle = startAngle + 90;
      
      const series = [
        // 24小时时钟刻度背景
        {
          type: 'gauge',
          center: ['50%', '50%'],
          radius: '85%',
          startAngle: 0,
          endAngle: 360,
          min: 0,
          max: 24,
          splitNumber: 24,
          axisLine: {
            show: false
          },
          axisTick: {
            show: true,
            length: 6,
            lineStyle: {
              color: '#CCCCCC',
              width: 1
            },
            distance: -8
          },
          splitLine: {
            show: true,
            length: 10,
            lineStyle: {
              color: '#CCCCCC',
              width: 1
            },
            distance: -8
          },
          axisLabel: {
            show: false
          },
          pointer: {
            show: false
          },
          detail: {
            show: false
          }
        },
        // 睡眠阶段环形饼图
        {
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['60%', '72%'], // 内半径60%，外半径72%，形成更细的环形
          startAngle: pieStartAngle,
          data: pieData,
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderRadius: [12, 12], // 设置圆角，让扇形两端有圆角效果，相邻扇形看起来压在一起
            borderWidth: 0
          },
          emphasis: {
            disabled: true
          },
          animation: false
        }
      ];
      
      const option = {
        series: series
      };
      
      this.chartInstance.setOption(option);
      
      // 解决高DPI屏幕模糊问题：设置高分辨率
      this.$nextTick(() => {
        const canvas = this.$refs.sleepChart.querySelector('canvas');
        if (canvas) {
          const container = this.$refs.sleepChart;
          const rect = container.getBoundingClientRect();
          const dpr = window.devicePixelRatio || 2;
          
          // 设置canvas实际尺寸为显示尺寸的2倍
          canvas.width = rect.width * dpr;
          canvas.height = rect.height * dpr;
          
          // 保持CSS显示尺寸不变
          canvas.style.width = rect.width + 'px';
          canvas.style.height = rect.height + 'px';
          
          // 重新渲染图表以应用新的尺寸
          this.chartInstance.resize();
        }
      });
    },
    /**
     * 将时间转换为角度（0-360度，0度在顶部）
     * @param {string} timeStr - 时间字符串，格式如 "23:29" 或 "2025-11-10 23:29:00"
     * @returns {number} 角度值
     */
    timeToAngle(timeStr) {
      if (!timeStr) return 0;
      
      // 确保是字符串类型
      const timeString = String(timeStr);
      
      let hour = 0;
      let minute = 0;
      
      // 处理不同格式的时间字符串
      if (timeString.includes(':')) {
        const timePart = timeString.includes(' ') ? timeString.split(' ')[1] : timeString;
        const parts = timePart.split(':');
        hour = parseInt(parts[0]) || 0;
        minute = parseInt(parts[1]) || 0;
      }
      
      // 将时间转换为角度（24小时制，0点在顶部，顺时针）
      // 0点 = 0度，6点 = 90度，12点 = 180度，18点 = 270度
      const totalMinutes = hour * 60 + minute;
      const angle = (totalMinutes / (24 * 60)) * 360;
      
      // 调整角度，使0点在顶部（-90度偏移）
      return (angle - 90 + 360) % 360;
    },
    /**
     * 解析时长字符串为分钟数
     * @param {string|number} durationStr - 时长字符串，如 "9小时7分" 或 "2小时17分"，也可能是数字（分钟数）
     * @returns {number} 分钟数
     */
    parseDuration(durationStr) {
      if (durationStr === undefined || durationStr === null || durationStr === '') return 0;
      
      // 如果是数字，直接返回
      if (typeof durationStr === 'number') {
        return durationStr;
      }
      
      // 确保是字符串类型
      const durationString = String(durationStr).trim();
      
      // 如果字符串是纯数字，直接转换为数字返回
      if (/^\d+$/.test(durationString)) {
        return parseInt(durationString, 10);
      }
      
      // 尝试匹配"X小时X分"格式
      const hourMatch = durationString.match(/(\d+)小时/);
      const minuteMatch = durationString.match(/(\d+)分/);
      
      const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
      const minutes = minuteMatch ? parseInt(minuteMatch[1], 10) : 0;
      
      return hours * 60 + minutes;
    },
    timeClick() {
      this.value = !this.value;
      console.log(this.value);
    },
    convertDateToTimestamp(dateString) {
      var parts = dateString.split("/");
      // 新 Date(年, 月 [, 日 [, 时 [, 分 [, 秒 [, 毫秒]]]]]) 中的月份是从0开始的，所以需要减1
      var date = new Date(parts[0], parts[1] - 1, parts[2]);
      return date.getTime();
    },
    timestampToDateFormat(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${month}月${day}日`; // 返回转换后的日期格式
    },
    timestampToDateFormat1(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${year}/${month}/${day}`; // 返回转换后的日期格式
    },
    timestampToDateFormat2(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${year}年${month}月${day}日`; // 返回转换后的日期格式
    },
    timeLeft() {
      this.week = this.getWeek(
        this.timestampToDateFormat1(
          this.convertDateToTimestamp(this.transferTime(this.time)) - 86400000
        )
      );
      this.leftTime =
        this.convertDateToTimestamp(this.transferTime(this.time)) - 86400000;
      this.time = this.timestampToDateFormat2(this.leftTime);
      this.newtime = this.timestampToDateFormat(this.leftTime);
      this.getData()
      console.log(this.timestampToDateFormat(this.leftTime));
      //console.log(this.leftTime)
      // console.log(this.week)
    },
    getTransferTime(data) {
      let str = data.replace(/\//g, '-');
      return str;
    },
    timeRight() {
      this.week = this.getWeek(
        this.timestampToDateFormat1(
        this.convertDateToTimestamp(this.transferTime(this.time)) + 86400000
        )
      );
      this.leftTime =
        this.convertDateToTimestamp(this.transferTime(this.time)) + 86400000;
      this.time = this.timestampToDateFormat2(this.leftTime);
      this.newtime = this.timestampToDateFormat(this.leftTime);
      console.log(this.timestampToDateFormat(this.leftTime));
      this.getData()
    },
    parentMethod(msg) {
      console.log(msg);
      this.time = msg;
      this.week = this.getWeek(this.transferTime(this.time));
      let originalString = msg;
      this.newtime = originalString.slice(5);
      this.name = this.data[0];
      this.getData();
    },
    closeMethod(msg) {
      this.bulletFrameIf = msg;
    },
    transferTime(data) {
      let str = data;
      let regex = /年/g; // 使用正则表达式并设置全局标志g
      let regex1 = /月/g; // 使用正则表达式并设置全局标志g
      var newStr = str.replace(regex, "/"); // 替换所有的"World"为"Earth"
      var newStr2 = newStr.replace(regex1, "/"); // 替换所有的"World"为"Earth"
      return newStr2.slice(0, -1);
    },
    getWeek(dateStr) {
      var date = ""; //周几
      let weeks = {
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六",
        0: "星期日",
      };
      date = new Date(dateStr);
      let weekIndex = date.getDay();
      date = weeks[weekIndex];
      return date;
    },
  },
};
</script>
<style lang="less" scoped>
.sleep-page {
  position: relative;
  min-height: 100vh;
  background: #F2F3F5;
  padding-bottom: 20px;
  
  /* 确保背景色覆盖整个页面，包括滚动区域 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F2F3F5;
    z-index: -1;
    pointer-events: none;
  }
  
  /* 顶部导航栏 - 参考 skinTemperature 页面 */
  .sleep-header {
    position: relative;
    width: 100%;
    min-height: 220px;
    overflow: hidden;
    margin-bottom: 0;
  }

  .header-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .header-bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .header-nav {
    position: relative;
    z-index: 100;
  display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    min-height: 44px;
  }

  .nav-back-btn {
    position: fixed;
    left: 16px;
    z-index: 1000;
    width: 28px;
    height: 28px;
  padding: 0;
    background: #ffffff;
    border: none;
    border-radius: 50%;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .nav-back-btn i {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }

  .nav-back-btn:hover {
    background: #f5f5f5;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-back-btn:active {
    transform: translateY(0) scale(0.95);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .nav-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  max-width: calc(100% - 120px);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .nav-placeholder {
    flex-shrink: 0;
    width: 28px;
  }

  /* 内容区域 */
  .sleep-content {
    width: 100%;
    padding: 16px;
  position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: transparent;
  }

  /* 日/周/月分段控制器 - 参考 heartRateDetails */
  .segmented-control {
    display: flex;
    background-image: url('~@/assets/heartRate/Rectangle_346242043@2x (1).png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 8px;
    padding: 4px;
    margin: 0 0 16px 0;
    gap: 4px;
  }

  .segment-item {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 15px;
    color: #666666;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 8px;
    font-weight: 400;
  }

  .segment-item.active {
    background-image: url('~@/assets/healthReportList/tab.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    color: #ffffff;
    font-weight: 500;
  }

  .segment-item:active {
    opacity: 0.8;
  }

  .sleep-daily-chart-wrap {
    position: relative;
    width: 100%;
    min-height: 220px;
    margin-bottom: 12px;
  }

  .sleep-daily-chart {
    width: 100%;
    height: 220px;
  }

  .sleep-daily-empty {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 13px;
  }

  .sleep-daily-tip {
    margin-top: 4px;
    text-align: center;
    font-size: 12px;
    color: #999999;
    line-height: 1.4;
  }

  /* 睡眠时长数据卡片 - 参考 bloodOxygen 页面 */
  .sleep-header-card {
    padding: 16px;
    margin: 0 0 16px 0;
    background-image: url('~@/assets/sleep/Rectangle_852@2x.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    overflow: hidden;
  }

  .sleep-header-top {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    gap: 10px;
  }

  .sleep-title-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
  }

  .sleep-title-section {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;

    .sleep-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 8px;
      background-image: url('~@/assets/sleep/Frame_3003@2x (2).png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      flex-shrink: 0;
    }

    .sleep-title-text {
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      flex-shrink: 0;
      white-space: nowrap;
    }
  }

  .sleep-selected-day {
    font-size: 13px;
    color: #999999;
    line-height: 1.2;
    white-space: nowrap;
  }

  .sleep-value-section {
    display: flex;
    align-items: baseline;

    .sleep-value {
      font-size: 28px;
      font-weight: bold;
      color: #000000;
      line-height: 1;
    }
  }

  .sleep-time-range {
    font-size: 14px;
    color: #999999;
    line-height: 1.3;

    &--hint {
      font-size: 12px;
    }
  }

  .sleep-date {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #000000;
    cursor: pointer;
    flex-shrink: 1;
    max-width: 55%;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    i {
      margin-left: 4px;
      font-size: 14px;
      color: #666666;
      flex-shrink: 0;
    }
  }

  /* 圆形图表容器 */
  .sleep-chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 16px 0;
    min-height: 170px;
    
    .sleep-chart-wrapper {
      flex-shrink: 0;
      position: relative;
      width: 170px;
      height: 170px;
      
      .sleep-chart {
        width: 100%;
        height: 100%;
      }
      
      .sleep-chart-score {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 10;
        pointer-events: none;
        
        .sleep-chart-score-value {
          font-size: 28px;
          font-weight: bold;
          color: #000000;
          line-height: 1.2;
          margin-bottom: 4px;
        }
        
        .sleep-chart-score-label {
          font-size: 12px;
          color: #666666;
          line-height: 1;
        }
      }
    }
  }

  /* 睡眠阶段图例 */
  .sleep-stage-legend {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 12px;
    margin-top: 16px;
    padding: 0;
  }

  /* 睡眠心率卡片 */
  .sleep-heart-rate-card {
    margin: 16px 0;
    padding: 16px;
    background-image: url('~@/assets/sleep/Rectangle_853@2x (5).png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    overflow: hidden;
  }

  .shr-header {
    margin-bottom: 16px;
  }

  .shr-title-section {
    display: flex;
    align-items: center;
  }

  .shr-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background-image: url('~@/assets/sleep/Frame_4359@2x.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    flex-shrink: 0;
  }

  .shr-title-text {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
  }

  .shr-chart-wrapper {
    margin: 16px 0;
    padding: 0;
    
    /* 隐藏 echarts 组件内部显示的心率值文本，因为我们已经在底部统计中显示了 */
    > div > div:first-child {
      display: none;
    }
  }

  .shr-stats {
    margin-top: 16px;
    background: #FFFFFF;
    border-radius: 10px;
    overflow: hidden;
  }

  .shr-stat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 0 16px;
    font-size: 14px;
    color: #000000;
    border-bottom: 1px solid #e5e5e5;

    &:last-child {
      border-bottom: none;
    }

    .shr-stat-label {
      display: flex;
      align-items: center;
      position: relative;
      font-weight: 400;
      color: #000000;
    }

    .shr-question {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      margin-left: 4px;
      background: #F5F5F5;
      border-radius: 50%;
      font-size: 12px;
      color: #999999;
      cursor: pointer;
      flex-shrink: 0;
    }

    .shr-stat-value {
      font-weight: 400;
      color: #000000;
    }
  }

  .sleep-stage-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 16px 8px;
    background: #FFFFFF;
    border-radius: 12px;
    
    .stage-label-row {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 6px;
      gap: 6px;
    }
    
    .stage-icon {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      flex-shrink: 0;
      
      &.deep-sleep-icon {
        background: #4B37FF;
      }
      
      &.light-sleep-icon {
        background: #7B76FF;
      }
      
      &.rem-sleep-icon {
        background: #43D867;
      }
    }
    
    .stage-label {
      font-size: 11px;
      color: #666666;
      text-align: center;
      line-height: 1.4;
    }
    
    .stage-value {
      display: flex;
      align-items: baseline;
      justify-content: center;
      text-align: center;
      
      .stage-value-number {
        font-size: 16px;
        font-weight: bold;
        color: #000000;
        line-height: 1;
      }
      
      .stage-value-unit {
        font-size: 12px;
        font-weight: normal;
        color: #666666;
        margin-left: 2px;
        line-height: 1;
      }
    }
  }
}

* {
  // margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}
#myCanvas1 #myId {
  height: 7.5rem !important;
}
.time {
  font-size: 15px;
  color: #636363;
  text-align: center;
}

.down-arrow:after {
  content: "";
  display: block;
  width: 0px;
  height: 0px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #666666;
  margin-top: 10px;
}
.totalBox {
  width: 93%;
  height: 95px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 16px;
  padding: 24px 10px;
}
.numberTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 22px;
  color: #333333;
  line-height: 33px;
  text-align: center;
  font-style: normal;
}
.nameTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 13px;
  color: #999999;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}
.defeat {
  width: 100%;
  height: 40px;
  background: #f3f3f3;
  border-radius: 10px;
  margin-top: 16px;
  display: flex;
  /* justify-content: center;  */
  align-items: left;
}
.drop {
  width: 8px;
  height: 8px;
  background: #209f66;
  border-radius: 100%;
  margin: 0px 10px;
}
.defeatName {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center; /* 垂直居中 */
  margin-left: 10px;
}
.paceTiele {
  width: 93%;
  height: 88px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 16px;
  /* padding: 12px 0px; */
}
.reachTheStandardTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: 800;
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  padding-left: 16px;
  position: relative;
}
.total {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 44px;
  line-height: 44px;
  padding-left: 16px;
  border-bottom: 1px solid #e5e5e5;
  margin-top: 5px;
}
.thisWeek {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 44px;
  line-height: 44px;
  padding-left: 16px;
  /* margin-top: 8px; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.lastweek {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 43px;
  line-height: 43px;
  padding-left: 16px;
  margin-top: 8px;
}
.continuous {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 43px;
  line-height: 43px;
  padding-left: 16px;
  /* margin-top: 5px; */
}
.day {
  float: right;
  margin-right: 8px;
  font-size: 14px;
  color: #151515;
}
/* 睡眠统计卡片 - 优化样式 */
.sleep-stats-card {
  margin: 0 0 12px 0;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  
  .ssc-title {
    display: flex;
    align-items: center;
    padding: 12px 16px 8px 16px;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    line-height: 1.2;
    position: relative;
    
    span {
      flex: 1;
      display: inline-flex;
      align-items: center;
      
      .ssc-question {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        margin-left: 4px;
        background: #F5F5F5;
        border-radius: 50%;
        font-size: 11px;
        color: #999999;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }
  
  .ssc-content {
    padding: 0 16px 12px 16px;
  }
  
  .ssc-value-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  
  .ssc-main-value {
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    flex: 1;
  }
  
  .ssc-progress-wrapper {
    margin: 8px 0;
  }
  
  .ssc-progress-bar {
    position: relative;
    width: 100%;
    height: 10px;
    background-color: #e5e5e5;
    border-radius: 5px;
    overflow: visible;
    margin-top: 30px;
  }
  
  .ssc-progress-fill {
    height: 10px;
    background: linear-gradient(231deg, #00c275 0%, #00b5ba 100%);
    border-radius: 5px;
  }
  
  .ssc-progress-dot {
    position: absolute;
    width: 15px;
    height: 15px;
    background: #ffffff;
    border: 2px solid #00c275;
    border-radius: 50%;
    top: -2.5px;
    transform: translateX(-50%);
  }
  
  .ssc-progress-label {
    position: absolute;
    top: -24px;
    left: 180%;
    transform: translateX(-50%);
    font-size: 12px;
    color: #209f66;
    white-space: nowrap;
  }
  
  .ssc-status-tag {
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
  }
  
  .ssc-state {
    width: 56px;
    height: 28px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    
    &.ssc-state-normal {
      background: rgba(32, 159, 102, 0.1);
      color: #209f66;
    }
    
    &.ssc-state-low {
      background: rgba(253, 221, 70, 0.1);
      color: #ffd200;
    }
    
    &.ssc-state-high {
      background: rgba(255, 0, 0, 0.1);
      color: #ff0000;
    }
  }
  
  .ssc-reference {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #999999;
    margin-top: 4px;
  }
}

.weeklySteps {
  margin-top: 16px;
  width: 93%;
  height: 113px;
  background: #ffffff;
  border-radius: 10px;
  padding: 12px 5px;
}
.progressDiv {
  width: 92%;
  margin-top: 1.5px;
  position: relative;
}
.progress-bar {
  width: 100%;
  background-color: #e5e5e5;
  border-radius: 50px;
  overflow: hidden;
}

.progress {
  height: 5px;
  background: linear-gradient(231deg, #00c275 0%, #00b5ba 100%);
  border-radius: 50px;
  /* transition: width 1s ease; */
  margin-left: 0 !important;
}
.last {
  height: 5px;
  background: linear-gradient(231deg, #ffa94a 0%, #ff8e32 100%) !important;
  border-radius: 50px;
  margin-left: 0 !important;
}
.lastDay {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border: 2px solid #ff9315 !important;
  border-radius: 100%;
  position: absolute;
  top: -1.5px;
}
.progressDay {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border: 2px solid #00c275;
  /* transition: width 1s ease; */
  border-radius: 100%;
  position: absolute;
  top: -1.5px;
}
.legend {
  font-size: 13px;
  background-color: #f3f4f6 !important;
  padding: 20px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.deepSleep {
  width: 8px;
  height: 8px;
  background: #008c00;
  border-radius: 100%;
  display: inline-block;
}
.question {
  width: 16px;
  height: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
  background: #dcdcdc;
  position: absolute;
  right: -22px;
  top: 2px;
  font-size: 13px;
}
.question1 {
  left: -105px;
  top: 3px;
  right: none;
}
.state {
  width: 56px;
  height: 28px;
  background: rgba(32, 159, 102, 0.1);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #209f66;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  float: right;
  margin-right: 8px;
}
.state1 {
  width: 56px;
  height: 28px;
  background: rgba(253, 221, 70, 0.1);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffd200;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  float: right;
  margin-right: 8px;
}
.state2 {
  width: 56px;
  height: 28px;
  background-color: rgba(255, 0, 0, 0.1);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: red;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  float: right;
  margin-right: 8px;
}
.referto {
  color: #999999;
  font-size: 13px;
  margin: 0;
  padding-left: 16px;
}
.referto2 {
  float: right;
  margin-right: 8px;
}
.jdt {
  width: 128px;
}
.jdtzb {
  position: absolute;
  width: 100px;
  left: -22px;
  top: -34px;
  font-weight: 400;
  font-size: 12px;
  color: #209f66;
  font-style: normal;
}
.echartsBar {
  width: 144px;
  height: 144px;
  border: 17px solid #f8f8f8;
  /* opacity: 0.68; */
  border-radius: 100%;
  position: relative;
  margin-left:24px;
  margin-top:40px
}
.Y {
  width: 130px;
  height: 130px;
  border: 1px solid #00c275;
  opacity: 0.22;
  border-radius: 100%;
  position: absolute;
  top: -9px;
  left: -8px;
}
.chart {
    top: -24px;
    width: 160px;
    height: 160px;
    left: -23px;
}
.smdf {
  color:#4A4A4A;
  font-size: 12px;
  text-align: center;
}
.df {
  font-family: HiraginoSansGB, HiraginoSansGB;
font-weight: normal;
font-size: 16px;
color: #333333;
font-style: normal;
text-align: center;
}
.smDiv {
  position: absolute;
    top: 39px;
    left: 33px;
}
.smtit {
  width: 73px;
height: 31px;
background: #00C275;
border-radius: 6px;
font-weight: normal;
font-size: 13px;
color: #FFFFFF;
line-height: 31px;
text-align: center;
font-style: normal;
margin-left: 0px;
}
.smtime {
  font-family: HiraginoSansGB, HiraginoSansGB;
font-weight: normal;
font-size: 16px;
color: #333333;
margin:8px 0px;
font-style: normal;
}
.border {
  border-top: 1px dashed #C0C0C0;
  width: 130%;
}
.right {
  margin-top:10px
}
.lenlist {
  margin: 10px 0px;
  color: #151515;
  font-size: 13px;
}
.sellpTime {
  font-size: 14px;
  position: absolute;
  top: 23px;
  left: 58px;
}
</style>


// WEBPACK FOOTER //
// src/views/sleep/index.vue